import Vue from 'vue';
import Tab from '../general/tab';
import axios from 'axios';
import * as FormHelpers from '../../helpers/formhelpers';
import 'jquery-validation';

export default Vue.component('pickupdetailtab', {
    extends: Tab,
    data: function(){
        return {
            servicePointId: null,
            axe: axios.create({
                baseURL: '/mywecycle/servicepoint'
            }),
            form: null,
            validator: null
        }
    },
    methods:{
        /**
         *Initializes the pickup details tab form
         *
         * @param {*} tabElem
         */
        initializeForm(tabElem){
            this.form = tabElem.find('.js-pickup-details');
            this.validator = this.form.validate({
                errorClass: 'invalid-feedback animated fadeIn',
                errorElement: 'div',
                errorPlacement: (error, el) => {
                    $(el).addClass('is-invalid');
                    $(el).parents('.form-group').append(error);
                },
                highlight: el => {
                    $(el).parents('.form-group').find('.is-invalid').removeClass('is-invalid').addClass('is-invalid');
                },
                success: el => {
                    $(el).parents('.form-group').find('.is-invalid').removeClass('is-invalid');
                    $(el).remove();
                },
            });
        },
        validateTab(){
            let validTab = false;

            if (!MyStichtingOpen.ServicePoints.checkMinimumOpeningHours()) {
                $('[data-toggle="minimalhourswarning"]').removeClass('d-none');
            } else {
                $('[data-toggle="minimalhourswarning"]').addClass('d-none');
                validTab = this.validator.form();
            }

            return validTab;
        },
        saveTab(){
            if(this.validateTab()){
                let formData = FormHelpers.getFormData(this.form);

                this.axe.post('/servicepointpickupdetails', formData)
                    .then((response) => { return true; })
                    .then((submitedWithSuccess) => {
                        if(submitedWithSuccess){ this.$emit('submit', true); }
                    })
                    .catch((error) => {
                        console.log('Error saving detail tab : ' + error);
                        this.$emit('submiterror');
                    });        
            }
        },
        initializeContent(tabElem){
            this.initializeForm(tabElem);
            One.helpers(['core-bootstrap-popover', 'core-bootstrap-tooltip', 'core-toggle-class', 'select2', 'datepicker', 'masked-inputs', 'maxlength', 'table-tools-sections']);
            MyStichtingOpen.ServicePoints.openingHours();
        },
        loadContent(){
            this.servicePointId = this.$parent.servicePointId;
            this.axe.get('/servicepointpickupdetailstab?', { params: { servicePointId: this.servicePointId }})
            .then((response) => { return this.renderTabContent(response.data); })
            .then((tabElem) => { this.initializeContent(tabElem) })
            .catch((error) => { console.log('Error retrieving tab content : ' + error); });
        }
    },
    mounted(){

    },
    created() {
        this.loadContent();
    }
});